import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_end.jpg';

export default page;
